export type ErrorPresentationPlacement =
  | "toast"
  | "inline"
  | "page_banner"
  | "blocking_modal"
  | "retry"
  | "none";

const SLUG_PLACEMENT: Record<string, ErrorPresentationPlacement> = {
  "billing.already_subscribed": "toast",
  "billing.three_month_offer_ended": "toast",
  "billing.invalid_plan": "toast",
  "billing.invalid_interval": "toast",
  "tier.subscription_required": "blocking_modal",
  "broker.credentials_not_found": "blocking_modal",
  "broker_sync_inflight": "toast",
  "report_inflight": "toast",
  "reports.quota.inflight": "toast",
  "daily_report_limit": "toast",
  "reports.quota.weekly_limit": "toast",
  "weekly_report_limit": "toast",
  "symbol_required": "inline",
  "validation.unprocessable": "inline",
  "csv_import.parse_failed": "inline",
  "policy.simulate.inflight": "toast",
  "broker.account_not_found": "inline",
  "auth.forbidden": "blocking_modal",
};

export function resolveErrorPresentation(
  slug: string,
  options?: { isMutation?: boolean; isPageLoad?: boolean }
): ErrorPresentationPlacement {
  if (options?.isPageLoad) return "page_banner";
  const exact = SLUG_PLACEMENT[slug];
  if (exact) return exact;
  if (slug.startsWith("rate_limit.")) return "retry";
  if (slug.startsWith("auth.")) return "blocking_modal";
  if (options?.isMutation) return "toast";
  return "inline";
}
